import React ,{ useEffect,useState }from "react";
import { getSubsetsUserApi } from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./SubSet.module.css";
import { errorToast } from "../../Toast/Toast";

const SubSet = () => {
    const[data,setData]=useState([])
  useEffect(() => {
    getSubsetsList()
  }, []);

  const getSubsetsList = async () => {
    getSubsetsUserApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setData(res.list)
        }
      }else{
        console.error(res)
      }
    })
  };
  return (
    <div className={Style.pageHolder}>
      <BurgerMenuTitle title={"زیرمجوعه"} />
      <div className={Style.itemHolder}>
        <p className={Style.title}>اسامی زیرمجوعه های شما در بَرِست</p>
        <p className={Style.count}>تعداد کل زیرمجموعه ها : {data.length}</p>
        <div className={Style.nameHolder}>
            {data.map(item=>{
                return(
                    <h2 className={Style.name}>{item.full_name}</h2>
                )
            })}
        </div>
      </div>
    </div>
  );
};

export default SubSet;
